<template>
    <div>
        <div class="content-caption dashed">
            <span>清理单信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>自有清理单号</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.innerNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>记账凭证号</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.reservedNo || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>系统清理单号</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核人</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.auditorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>说明</label>
                </div>
                <div class="form-value">
                    <span>{{fiscalClearInfo.memo || '无'}}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <div class="simple-row">
            <div class="right">
                <span>已选择({{(fiscalClearInfo.itemList || []).length}})</span>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="fiscalClearInfo.itemList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="left" prop="newTmpNo" min-width="250" label="系统编号" fixed show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="newDevcInnerCode" min-width="150" label="资产编号" fixed show-overflow-tooltip>
                    <template slot-scope="rows">
                        <a class="table-cell-link" @click="viewAssetInfo(rows.row, true);">{{rows.row.newDevcInnerCode}}</a>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="assetType" min-width="150" label="管理方式" fixed show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{assetTypeMap[rows.row.assetType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="retailerComFullName" label="部门全称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="title" label="资产描述全称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="name" label="名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="model" label="型号" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="vendorUkno" min-width="120" label="商品标识码" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcCatFullName" min-width="200" label="资产分类" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcBrandCode" min-width="150" label="资产品牌编码" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerDevcBrandName" min-width="150" label="资产品牌" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="acctEnterWay" min-width="150" label="入账方式" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{acctEnterWayMap[rows.row.acctEnterWay]}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" width="100" label="清理数量"></el-table-column>
                <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                <el-table-column align="left" prop="handleDesc" min-width="100" label="处理说明" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="extraIncome" width="100" label="额外收入(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.extraIncome != null">{{rows.row.extraIncome.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="extraCostFee" width="100" label="额外费用(元)">
                    <template slot-scope="rows">
                        <span v-if="rows.row.extraCostFee != null">{{rows.row.extraCostFee.toFixed(2)}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>

</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { assetFiscalInfoDlg } from '../retailer/dialog'

    import shopDeviceApi from '../../api/shopDevc'
    import assetFiscalApi from '../../api/assetFiscal'
    //

    export default {
        name: 'swb-asset-fiscal-clear-voucher-view',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '清理单详情',
        props: ['id'],
        data: function () {
            return {
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                fiscalClearInfo: {},
                //
                deprMethodCodeMap: {},
                acctEnterWayMap: getEnumMap("acctEnterWay", "value2text"),
                assetTypeMap: getEnumMap("assetType", "value2text")
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.deprMethodCodeMap = getEnumMap("assetDeprMethod", "name2text");
            this.getAssetFiscalClearVoucher();
        },
        methods: {
            getAssetFiscalClearVoucher: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                assetFiscalApi.getAssetFiscalClearVoucherInfo(postData, function (result) {
                    if(result.type == "info") {
                        let fiscalClearInfo = result.data;
                        self.fiscalClearInfo = Utils.merge({}, fiscalClearInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 查看资产信息
            viewAssetInfo: function (row, newAsset) {
                let devcInnerCode = row.devcInnerCode;
                if(Utils.isTrue(newAsset)) {
                    devcInnerCode = row.newDevcInnerCode;
                }
                let params = {
                    innerCode: devcInnerCode,
                    assetType: row.assetType
                };
                assetFiscalInfoDlg(params);
            }
        }
    }
</script>

<style>
    .form-info .form-row {
        height: 30px;
        line-height: 30px;
        margin-top: 6px;
        margin-bottom: 6px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/assetFiscal/AssetFiscalClearVoucherView.vue